<template>
  <div id="two_factor_form">
    <h3 class="mb-4">
      Two Factor Authentication
    </h3>
    <p>This device has not yet been verified by Two Factor Authentication, or the authentication has expired.</p>
    <form class="kt-form" data-vv-scope="two_factor_form" @submit.prevent="submitTwoFactorAuthentication()">
      <input type="hidden" name="user_uuid" :value="user_uuid">

      <div v-if="success">
        <div class="alert alert-success" role="alert">
          {{ success }}
        </div>
      </div>

      <div v-if="error">
        <div class="alert alert-danger" role="alert">
          {{ error }}
        </div>
      </div>

      <div class="form-group">
        <input id="device_name" v-model="form.device_name"
               v-validate="'required|alpha_spaces'"
               type="text"
               class="form-control"
               name="Device Name" required
               placeholder="Name this device"
               autofocus>
        <p v-show="errors.has('Device Name', 'two_factor_form')" class="validation-error help kt-font-danger">
          {{ errors.first('Device Name', 'two_factor_form') }}
        </p>
      </div>

      <div class="form-group">
        <input id="two_factor_code" v-model="form.two_factor_code"
               v-validate="'required|numeric'"
               type="text"
               class="form-control"
               name="two_factor_code" required
               placeholder="Enter Code"
               autofocus>
        <p v-show="errors.has('two_factor_code', 'two_factor_form')" class="validation-error help kt-font-danger">
          {{ errors.first('two_factor_code', 'two_factor_form') }}
        </p>
      </div>

      <div class="form-group mb-0">
        <div>
          <button type="button" class="btn btn-ss" @click="showForm('login_form')">
            Back
          </button>
          <button type="button" class="btn btn-ss" @click="resendCode()">
            Resend Code
          </button>
          <button id="submit_two_factor" type="submit" class="btn btn-ss-standout">
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AuthFormsMixin from "VueMixins/AuthFormsMixin";
export default {
  mixins: [AuthFormsMixin],
  data() {
    return {
      form: {
        two_factor_code: null,
        device_name: null,
      },
    };
  },
  methods: {
    async resendCode() {
      axios.get(`/2fa/${window.user_uuid}/resend`).then(() => {
        this.setSuccess("Authentication code resent, please check your emails and spam.");
      }).catch(() => {
        this.setError("Unable to resend two factor code to your email address. Please contact SharpStream Support.");
      });
    },
    async submitTwoFactorAuthentication() {
      this.laddaButton("submit_two_factor");
      this.$validator.validateAll('two_factor_form').then((result) => {
        if (result) {
          this.form.user_uuid = window.user_uuid;
          this.form._token = window.csrfToken;
          axios.post('/2fa', this.form).then(() => {
            this.setSuccess("Device Authenticated. Logging you in...");
            window.location.href = "/";
            this.unLaddaButton("submit_two_factor");
          }).catch((error) => {
            this.setError(error.response.data.message);
            this.unLaddaButton("submit_two_factor");
          });
        } else {
          this.unLaddaButton("submit_two_factor");
        }
      });
    },
  },
};
</script>
